import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "serp__filters-header",
  class: "q-px-3 q-fs-5 q-my-2 q-fw-semibold"
}

import {inject} from "vue";
import {SmartSearchTranslationsInterface} from "@/core/types";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersHeaderContainer',
  setup(__props) {

const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(_unref(SmartSearchTranslations).filters.header), 1))
}
}

})